module.exports = __webpack_public_path__ + "static/media/alert-post@2x.6b41e68f.png";